import { IdeyaButton } from '../../../../common/antd/ideya-button/ideya-button.tsx'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'
import { useAppSelector } from '../../../../redux/hooks.ts'
import { selectUser } from '../../../../features/user/user.slice.ts'
import { blockedFirmIdsCreateEditIdea } from '../../../../utils/permissions.ts'

interface IdeaActionColumnProps {
  data: { id: string; state: string; canEdit: boolean }
  onEditIdea: (id: string) => void
  onViewIdea: (id: string) => void
}

export const IdeaActionColumn: React.FC<IdeaActionColumnProps> = ({
  data,
  onEditIdea,
  onViewIdea,
}) => {
  const userInfo = useAppSelector(selectUser)
  if (!data) return <></>

  return (
    <Row gutter={[8, 0]} wrap={false}>
      <Col>
        <IdeyaButton
          icon={<EyeOutlined />}
          onClick={() => onViewIdea(data.id)}
        />
      </Col>
      {data.canEdit &&
        !blockedFirmIdsCreateEditIdea.includes(userInfo.firmId) && (
          <Col>
            <IdeyaButton
              icon={<EditOutlined />}
              onClick={() => onEditIdea(data.id)}
            />
          </Col>
        )}
    </Row>
  )
}
